module.exports = __webpack_public_path__ + "img/not-authorized-dark.970d6347.svg";